import React from 'react';
import classNames from '../../utility/classNames';
import Tooltip from '../Tooltip';
import Icon from '../Icon';

export default function TextButton({
  text,
  handleClick,
  classes = '',
  srText,
  disabled = false,
  disabledMessage,
  loading = false,
  loadText = true,
}) {
  const button = () => (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled || loading}
      className={classNames(
        disabled
          ? 'text-gray-500 cursor-not-allowed rounded'
          : 'cursor-pointer rounded inline-flex justify-center items-center outline-none focus:outline-none  transition',
        classes ? classes : 'text-black'
      )}
      style={disabled ? { color: '#9CA3AF' } : {}}
    >
      {srText && <span className="sr-only">{srText}</span>}
      {!loading ? (
        text
      ) : (
        <div className="flex flex-row items-center gap-1 text-base">
          <span className="animate-spin">
            <Icon icon="BiLoaderAlt" className="text-xl"></Icon>
          </span>
          {loadText && <p className="mt-[0.2rem]">Working...</p>}
        </div>
      )}
    </button>
  );
  return (
    <>
      {disabled && disabledMessage ? (
        <Tooltip
          text={disabledMessage}
          classes="text-neutral-500"
          offset="-top-16"
        >
          {button()}
        </Tooltip>
      ) : (
        <>{button()}</>
      )}
    </>
  );
}
